import AppelerApi from './appeler-api.service';

let renouvellementId;

const renouvelerJeton = () => {
    if (!localStorage.getItem('jeton')) {
        return;
    }
    AppelerApi.get('/renouveller-jeton')
    .then(data => {
        localStorage.setItem('jeton', data.jeton);
    }).catch(_ => {});
};

export default {
    lancerRenouvellementJeton() {
        if (renouvellementId) {
            return;
        }
        renouvellementId = setInterval(renouvelerJeton, 20 * 60 * 1000); // toutes les 20 minutes
        setTimeout(renouvelerJeton, 60 * 1000); // renouveller après 1 minute au cas où on recharge souvent
    }
};